const SP_HOST = 'https://litehouseinc.sharepoint.com';

export const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_CLIENT_ID,
    authority: `https://login.microsoftonline.com/${process.env.REACT_APP_TENANT_ID}`,
    redirectUri: process.env.REACT_APP_REDIRECT_URI || window.location.origin,
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false,
  },
};

// Used for sign-in and user profile
export const loginRequest = {
  scopes: ['User.Read'],
};

// Used for SharePoint REST API calls — authenticates directly against SharePoint
export const spRequest = {
  scopes: [`${SP_HOST}/AllSites.Write`],
};

// Used for Microsoft Graph API calls (e.g. user directory search)
// Requires User.ReadBasic.All — may need admin consent in Azure AD
export const graphRequest = {
  scopes: ['User.ReadBasic.All'],
};
